import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Btn } from "@/components/ui/Btn/Btn";
import { Icon } from "@/components/ui/Icon/Icon";
import { Input } from "@/components/ui/Input/Input";
import { AuthLayout } from "@/components/auth/AuthLayout";
import { Banner, Field, FormShell } from "@/components/auth/FormShell";
import formStyles from "@/components/auth/AuthForm.module.css";
import { forgotPassword, type AuthError } from "@/lib/auth";

export function ResetRequest() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState<AuthError | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await forgotPassword(email.trim());
      navigate(`/reset/sent?email=${encodeURIComponent(email.trim())}`, { replace: true });
    } catch (err) {
      setError(err as AuthError);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthLayout view="reset-request">
      <FormShell
        title="Reset your password"
        subtitle="Enter the email you signed up with and we’ll send a one-time 6-digit code."
      >
        <form onSubmit={onSubmit} noValidate className={formStyles.stack}>
          {error && (
            <Banner variant="danger" icon={<Icon name="info" size={14} />}>
              {error.message}
            </Banner>
          )}
          <Field label="Email" htmlFor="reset-email">
            <Input
              id="reset-email"
              icon="user"
              type="email"
              inputMode="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@brand.com"
              required
            />
          </Field>
          <Btn
            type="submit"
            variant="primary"
            full
            size="lg"
            loading={submitting}
            iconRight={<Icon name="send" size={14} />}
          >
            Send recovery code
          </Btn>
          <div className={formStyles.backRow}>
            <Link to="/signin" className={formStyles.backLink}>
              <Icon name="arrow-left" size={12} />
              Back to sign in
            </Link>
          </div>
        </form>
      </FormShell>
    </AuthLayout>
  );
}
